<h1 mat-dialog-title>{{ data.dialog_title }}</h1>

<mat-dialog-content>
  @for (row of data.data; track row) {
    <mat-checkbox
      [checked]="isSelected(row.value)"
      [disabled]="row.disabled === true"
      (change)="!row.disabled && toggleSelection(row.value)"
    >
      {{ row.textToShow }}
    </mat-checkbox>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ data.dialog_cancel_button }}</button>
  <button mat-flat-button color="accent" (click)="submit()" [disabled]="selectedValues.length === 0">
    {{ data.dialog_ok_button }}
  </button>
</mat-dialog-actions>
